import { render, staticRenderFns } from "./CustomerContactTimeLineElement.vue?vue&type=template&id=4aee8513&"
import script from "./CustomerContactTimeLineElement.vue?vue&type=script&lang=ts&"
export * from "./CustomerContactTimeLineElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VIcon,VRow,VSpacer,VTimelineItem})
